import { ErrorPage } from './ErrorPage';

export const AppContentFallback = ({ error }: { error?: unknown }) => {
	return <ErrorPage error={error} />;
};
